'use client';

import { P } from '@/components/ui/typography';
import React, { useState } from 'react';

const handleNext = <T,>(index: number, array: T[]) => (index + 1) % array.length;

const TheaterText = ({
  smallVenues,
  largeVenues,
}: {
  smallVenues: string[];
  largeVenues: string[];
}) => {
  const [smallVenueIndex, setSmallVenueIndex] = useState(0);
  const [largeVenueIndex, setLargeVenueIndex] = useState(0);

  const handleNextSmall = () => setSmallVenueIndex(handleNext(smallVenueIndex, smallVenues));
  const handleNextLarge = () => setLargeVenueIndex(handleNext(largeVenueIndex, largeVenues));

  const smallVenue = smallVenues[smallVenueIndex];
  const largeVenue = largeVenues[largeVenueIndex];

  return (
    <P className="text-xl">
      QLab is powerful macOS software for designing and playing back sound, video, light, and show
      control cues. It&apos;s a flexible, reliable, and user-friendly tool used by everyone from{' '}
      <span className="bg-primary cursor-pointer" onClick={handleNextSmall}>
        {smallVenue}
      </span>{' '}
      to{' '}
      <span className="bg-primary cursor-pointer" onClick={handleNextLarge}>
        {largeVenue}
      </span>
      .
    </P>
  );
};

export default TheaterText;
